import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const revealVariants = {
    hidden: { opacity: 0, y: 18 },
    visible: { opacity: 1, y: 0 },
};

const GuestScrollReveal = ({ children, className = "", delay = 0 }) => {
    const shouldReduceMotion = useReducedMotion();

    if (shouldReduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <motion.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15, margin: "0px 0px -32px 0px" }}
            variants={revealVariants}
            transition={{
                duration: 0.45,
                ease: [0.25, 0.46, 0.45, 0.94],
                delay,
            }}
        >
            {children}
        </motion.div>
    );
};

export default GuestScrollReveal;
